module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/navigation/waiting-ddb3303fe5831f6dda088289f9412307.svg";